import { FunctionComponent } from 'react'

import { Box } from 'native-base'
import Svg, { Path, G, Defs, Rect, ClipPath } from 'react-native-svg'

type WorkLifeBalanceIllustrationProps = {
  maxH?: number
}

export const WorkLifeBalanceIllustration: FunctionComponent<WorkLifeBalanceIllustrationProps> = ({
  maxH = 250
}) => (
  <Box {...{ maxH }}>
    <Svg width={251} height={250} viewBox="0 0 251 250" fill="none">
      <G clipPath="url(#clip0_8955_170133)">
        <Path
          d="M20.1899 201.599C21.2299 206.939 23.7299 211.879 27.4199 215.879C31.1099 219.869 35.8499 222.759 41.0899 224.209L49.1899 196.439L20.1899 201.589V201.599Z"
          fill="#E62140"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M78.0599 196.07C78.0599 212.2 64.9799 225.28 48.8499 225.28C46.1599 225.28 43.5499 224.92 41.0799 224.23L49.1899 196.45L20.1599 201.61C19.8099 199.82 19.6299 197.96 19.6299 196.07C19.6299 179.93 32.7099 166.85 48.8499 166.85C64.9899 166.85 78.0599 179.93 78.0599 196.07Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M55.9502 55.1707L48.6602 40.9907C48.6602 40.9907 49.6502 37.9707 52.0602 39.5507C52.0602 39.5507 51.8602 35.8207 55.0102 36.9607C55.0102 36.9607 55.8802 33.8307 58.9202 35.1707C58.9202 35.1707 60.2402 31.9407 62.6602 33.6707L63.8402 36.2907C63.8402 36.2907 65.3902 35.8907 66.4002 37.4707C67.4102 39.0507 68.5102 41.0607 68.5102 41.0607C68.5102 41.0607 69.2802 42.1807 67.9002 44.1607C66.5202 46.1407 66.3302 48.6607 66.7502 49.6307C67.1702 50.6007 55.9502 55.1607 55.9502 55.1607V55.1707Z"
          fill="#F5F5F5"
        />
        <Path
          d="M113.14 50.1803C113.17 50.2703 113.21 50.3603 113.24 50.4503C112.96 49.7003 112.31 49.1003 111.42 48.5803C111.13 48.4103 110.81 48.2503 110.47 48.1003C110.13 47.9503 109.77 47.8003 109.4 47.6603C109.02 47.5203 108.64 47.3903 108.24 47.2603C107.65 47.0603 107.03 46.8703 106.42 46.6803C106.01 46.5503 105.6 46.4303 105.2 46.3003C104.6 46.1103 104.01 45.9103 103.45 45.7003C103.07 45.5603 102.71 45.4103 102.38 45.2603C102.13 45.1403 101.88 45.0203 101.65 44.9003C101.42 44.7803 101.2 44.6403 101 44.5103C99.2502 43.3103 98.7202 41.6303 101 38.8303C98.7902 26.3103 108.75 30.4503 113.78 33.5803C113.18 33.2203 112.64 32.9503 112.15 32.7803C110.81 32.2803 109.85 32.4003 109.21 32.9003C109.13 32.9503 109.06 33.0203 109 33.0803C107.99 34.0903 107.89 36.1303 108.32 37.9703C108.34 38.1103 108.38 38.2403 108.42 38.3703C108.51 38.7203 108.63 39.0603 108.76 39.3803C108.82 39.5303 108.88 39.6703 108.95 39.8103C108.99 39.9003 109.03 39.9903 109.08 40.0703C109.11 40.1403 109.13 40.2003 109.14 40.2603V40.3403C109.15 40.4103 109.15 40.4703 109.15 40.5303C109.14 40.5903 109.13 40.6403 109.11 40.6803C109.08 40.7403 109.04 40.7903 108.98 40.8203C108.76 40.9303 108.34 40.9303 107.63 40.7803C107.29 40.7103 106.99 40.7103 106.73 40.7603C106.63 40.7803 106.53 40.8103 106.44 40.8403C106.28 40.9103 106.14 41.0003 106.02 41.1103C106.01 41.1103 106 41.1203 105.99 41.1303C105.9 41.2203 105.82 41.3203 105.77 41.4403C105.72 41.5503 105.67 41.6703 105.64 41.8003C105.6 42.0303 105.61 42.2703 105.68 42.5203C105.7 42.6203 105.74 42.7103 105.78 42.8103C105.85 43.0003 105.97 43.1903 106.12 43.3703C106.2 43.4603 106.28 43.5503 106.37 43.6403C106.51 43.7803 106.68 43.9203 106.88 44.0303C106.96 44.0903 107.04 44.1303 107.12 44.1703C107.22 44.2203 107.33 44.2703 107.44 44.3203C107.58 44.3803 107.74 44.4403 107.9 44.4903C108.16 44.5703 108.45 44.6303 108.76 44.6803C109.07 44.7203 109.41 44.7503 109.77 44.7503C110.85 45.9203 111.75 47.2303 112.46 48.6503C112.6 48.9403 112.74 49.2403 112.87 49.5403C112.96 49.7503 113.05 49.9603 113.13 50.1803H113.14Z"
          fill="#2E2E2E"
        />
        <Path
          d="M111.42 80.9404V80.9704L110.56 84.0804H108.85C108.68 83.5704 108.49 83.0204 108.33 82.4604C108.33 82.4604 108.327 82.4538 108.32 82.4404C108.86 82.1904 109.38 81.9404 109.9 81.6904C110.41 81.4404 110.92 81.1904 111.42 80.9404Z"
          fill="#2E2E2E"
        />
        <Path
          d="M119.21 48.0504L115.55 46.8804C115.55 46.8804 115.64 46.8704 115.79 46.8304C115.88 46.8204 115.96 46.8004 116.05 46.7704C116.5 46.6704 117.21 46.4704 117.97 46.1504C117.97 46.1504 118.45 46.8604 119.21 48.0504Z"
          fill="#2E2E2E"
        />
        <Path
          d="M118.14 46.0703C118.08 46.1003 118.02 46.1203 117.97 46.1503"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M116.05 46.7705C115.95 46.8005 115.86 46.8205 115.79 46.8305"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M188.67 37.6506C187.26 32.4906 183.97 27.4906 178.98 22.6406C162.27 33.2106 149.28 40.7306 129.51 49.7306C124.81 51.8806 122.28 52.7206 121.04 50.8306L118.14 46.0706C120.94 44.8006 124.03 41.7806 116.05 35.2506C115.33 34.6506 112.95 33.2706 112.16 32.7806C110.82 32.2806 109.86 32.4006 109.22 32.9006C109.14 32.9506 109.07 33.0206 109.01 33.0806C108 34.0906 107.9 36.1306 108.33 37.9706C108.36 38.1006 108.39 38.2406 108.43 38.3706C108.52 38.7206 108.64 39.0606 108.77 39.3806C108.83 39.5306 108.89 39.6706 108.96 39.8106C109 39.9006 109.04 39.9906 109.09 40.0706C109.12 40.1406 109.14 40.2006 109.15 40.2606C109.19 40.4306 109.19 40.5806 109.12 40.6806C109.09 40.7406 109.05 40.7906 108.99 40.8206C108.75 40.9806 108.27 40.9506 107.62 40.8006C107.29 40.7306 107 40.7206 106.74 40.7606C106.64 40.7806 106.54 40.8106 106.45 40.8406C106.29 40.9106 106.15 41.0006 106.03 41.1106C106.02 41.1106 106.01 41.1206 106 41.1306C105.91 41.2206 105.83 41.3206 105.78 41.4406C105.73 41.5506 105.68 41.6706 105.65 41.8006C105.61 42.0306 105.62 42.2706 105.69 42.5206C105.71 42.6206 105.75 42.7106 105.79 42.8106C105.87 43.0006 105.99 43.1906 106.13 43.3706C106.21 43.4606 106.29 43.5506 106.38 43.6406C106.45 43.7006 106.52 43.7606 106.6 43.8206C106.68 43.8806 106.75 43.9406 106.83 43.9906C106.85 44.0106 106.87 44.0206 106.89 44.0306C106.97 44.0806 107.05 44.1206 107.13 44.1706C107.23 44.2206 107.34 44.2706 107.45 44.3206C107.59 44.3806 107.75 44.4406 107.91 44.4906C108.17 44.5706 108.46 44.6306 108.77 44.6806C109.08 44.7206 109.42 44.7506 109.78 44.7506C110.86 45.9206 111.76 47.2306 112.47 48.6506C112.6 48.8806 112.74 49.1806 112.88 49.5406C112.97 49.7506 113.06 49.9606 113.14 50.1806C113.17 50.2706 113.21 50.3606 113.24 50.4506C113.71 51.7606 114.12 53.3206 114.15 54.1506C114.15 56.5806 112.49 60.3106 85.3401 70.3306C84.7501 70.5506 82.9801 71.2206 81.1801 71.9206L73.1701 55.1706C67.0301 56.1806 61.3001 58.8906 56.6201 62.9906L66.5001 84.1006C68.2501 86.6606 70.0601 91.2206 72.1301 93.5306C72.9001 94.3906 73.7701 95.2706 74.9001 95.5606C75.7301 95.7606 76.6101 95.6106 77.4601 95.4506C87.4701 93.5406 95.4501 88.3006 104.74 84.1006C105.96 83.5406 107.16 82.9906 108.32 82.4406C108.86 82.1906 109.38 81.9406 109.9 81.6906C110.41 81.4406 110.92 81.1906 111.42 80.9406V80.9706L110.56 84.0806V84.1006H145.31C144.69 76.9206 143.59 69.1706 142.3 63.7306C158.65 56.5706 173.45 47.8506 188.67 37.6506ZM115.55 46.8806C115.55 46.8806 115.64 46.8706 115.79 46.8306C115.88 46.8206 115.96 46.8006 116.05 46.7706C116.5 46.6706 117.21 46.4706 117.97 46.1506C117.97 46.1506 118.45 46.8606 119.21 48.0506L115.55 46.8806Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M142.3 63.7305C142.11 63.8105 141.92 63.9005 141.73 63.9805"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M194.12 33.9605C192.29 35.2105 190.48 36.4505 188.67 37.6505C187.26 32.4905 183.97 27.4905 178.98 22.6405C180.71 21.5305 182.48 20.4005 184.31 19.2305C185.3 19.9905 186.23 20.7605 187.1 21.5505C190.13 24.3205 192.41 27.3605 193.51 31.0105C193.8 31.9505 194 32.9305 194.12 33.9605Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M118.14 46.0704L117.91 45.6904"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M54.93 43.6304C56.38 46.0104 59.42 44.5504 58.18 42.1604C57.26 40.3804 56.54 39.1704 55.76 37.7804C54.45 35.4804 51.31 37.0904 52.22 39.0904C53.05 40.6504 53.95 42.1604 54.93 43.6304Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M64.0603 36.7204C63.6303 35.8404 63.3103 35.2004 62.9003 34.3704C61.7803 32.0804 58.5503 33.6304 59.3403 35.5804C59.7603 36.5704 60.2403 37.5304 60.8003 38.4604"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M51.8201 45.9307C53.2901 48.1907 56.2001 46.7107 54.9301 44.4607C53.9801 42.7707 53.2601 41.6107 52.4601 40.3007C51.1201 38.1207 48.1001 39.7607 49.0601 41.6307C49.6501 42.7707 50.4801 43.8707 51.8101 45.9307H51.8201Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M60.7101 38.5008C60.2101 37.6008 59.7401 36.8408 59.2601 35.9608C57.9801 33.5808 54.7401 35.1808 55.6301 37.2208C56.1701 38.4608 56.9701 39.6508 58.2701 41.9008C58.4401 42.2508 58.7101 42.5308 59.0601 42.7108C59.4001 42.8908 59.7901 42.9508 60.1801 42.8908C60.5601 42.8308 60.9101 42.6508 61.1801 42.3708C61.4501 42.0908 61.6201 41.7408 61.6701 41.3508"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M67.38 50.1809C66.45 48.8309 66 47.4309 68.14 43.7409C69.16 41.9809 68.99 41.7009 67.28 38.8509C65.28 35.5009 65.29 35.8909 59.49 39.1809C58.07 39.9909 59.18 42.6009 64.05 40.7209C60.3 42.1209 58.67 44.9709 59.13 47.7709"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M56.1701 55.6207C54.2201 51.4907 50.4001 45.0007 49.1201 41.6807"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M201.93 25.2704C198.97 26.9504 196.16 28.8704 193.51 31.0104C192.41 27.3604 190.13 24.3204 187.1 21.5504C189.83 19.9204 194.32 18.4004 202.31 9.07043C205.47 5.38043 206.95 5.46043 204.62 10.3304C204.46 10.6604 204.23 11.1304 203.92 11.7104C203.24 13.0004 202.22 14.8704 200.98 17.1504C200.03 18.8804 198.95 20.8504 197.8 22.9904C199.51 23.0004 201.21 22.9204 202.91 22.7504C204.97 22.6704 206.94 22.4704 201.93 25.2704Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M187.1 21.5508L187.09 21.5608"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M197.8 22.9902C197.51 23.5102 197.22 24.0502 196.92 24.6002"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M207.9 11.99C206.04 13.26 202.6 15.87 200.98 17.15C202.22 14.87 203.24 13 203.92 11.71C205.64 10.78 207.46 10.1 209.37 9.67001C209.91 9.59001 210.68 10.1 207.9 11.99Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M203.92 11.71C203.92 11.71 203.89 11.72 203.88 11.73"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M193.51 31.0107L193.5 31.0207"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M50.6401 44.9805L30.8301 56.2205"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M87.5001 24.0801L65.5801 36.5301"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M76.1699 24.3405L87.5499 24.0605L81.4699 33.6805"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M113.14 50.1803C113.17 50.2703 113.21 50.3603 113.24 50.4503C112.96 49.7003 112.31 49.1003 111.42 48.5803C111.13 48.4103 110.81 48.2503 110.47 48.1003C110.13 47.9503 109.77 47.8003 109.4 47.6603C109.02 47.5203 108.64 47.3903 108.24 47.2603C107.65 47.0603 107.03 46.8703 106.42 46.6803C106.01 46.5503 105.6 46.4303 105.2 46.3003C104.6 46.1103 104.01 45.9103 103.45 45.7003C103.07 45.5603 102.71 45.4103 102.38 45.2603C102.13 45.1403 101.88 45.0203 101.65 44.9003C101.42 44.7803 101.2 44.6403 101 44.5103C99.2502 43.3103 98.7202 41.6303 101 38.8303C98.7902 26.3103 108.75 30.4503 113.78 33.5803C113.18 33.2203 112.64 32.9503 112.15 32.7803C110.81 32.2803 109.85 32.4003 109.21 32.9003C109.13 32.9503 109.06 33.0203 109 33.0803C107.99 34.0903 107.89 36.1303 108.32 37.9703C108.35 38.1003 108.38 38.2403 108.42 38.3703C108.51 38.7203 108.63 39.0603 108.76 39.3803C108.82 39.5303 108.88 39.6703 108.95 39.8103C109.06 40.0203 109.12 40.2003 109.14 40.3403C109.15 40.4103 109.15 40.4703 109.15 40.5303C109.14 40.5903 109.13 40.6303 109.11 40.6803C109.08 40.7403 109.04 40.7903 108.98 40.8203C108.74 40.9803 108.26 40.9503 107.61 40.8003C107.28 40.7303 106.99 40.7203 106.73 40.7603C106.63 40.7803 106.53 40.8103 106.44 40.8403C106.27 40.9003 106.13 40.9903 106.02 41.1103C106.01 41.1103 106 41.1203 105.99 41.1303C105.9 41.2203 105.82 41.3203 105.77 41.4403C105.71 41.5503 105.66 41.6703 105.64 41.8003C105.6 42.0303 105.61 42.2703 105.68 42.5203C105.7 42.6203 105.74 42.7103 105.78 42.8103C105.86 43.0003 105.98 43.1903 106.12 43.3703C106.2 43.4603 106.28 43.5503 106.37 43.6403C106.51 43.7803 106.68 43.9203 106.88 44.0303C106.96 44.0803 107.04 44.1203 107.12 44.1703C107.22 44.2203 107.33 44.2703 107.44 44.3203C107.58 44.3803 107.74 44.4403 107.9 44.4903C108.16 44.5703 108.45 44.6303 108.76 44.6803C109.07 44.7203 109.41 44.7503 109.77 44.7503C110.85 45.9203 111.75 47.2303 112.46 48.6503C112.6 48.9403 112.74 49.2403 112.87 49.5403C112.96 49.7503 113.05 49.9603 113.13 50.1803H113.14Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M122.22 51.8701C121.6 55.0801 118.25 56.1501 113.6 56.2501"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M122.22 51.9004C122.22 51.9004 125.92 56.8204 126.23 57.3204C126.54 57.8104 120.63 54.5204 120.63 54.5204L117.9 61.3604L113.57 56.2504"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M120.63 54.5107C120.63 54.5107 131.51 68.0707 131.51 84.1007"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M73.1799 55.1709H73.1699"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M188.68 37.6904C188.68 37.6904 188.67 37.6604 188.67 37.6504"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M178.98 22.6409L178.97 22.6309"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M108.85 84.1C108.68 83.58 108.49 83.03 108.33 82.46"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M76.52 73.7009C76.52 73.7009 78.88 72.7909 81.18 71.9209"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M140.78 60.4106C156.71 52.7906 172.61 43.7206 187.28 33.8906"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M81.4502 72.4809L81.1802 71.9209"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M73.1702 55.1705C67.0302 56.1805 61.3002 58.8905 56.6202 62.9905L53.9102 57.1905C54.6402 56.6405 55.3902 56.1205 56.1602 55.6205C60.5102 52.7605 65.3202 50.6305 70.3702 49.3105L73.1702 55.1705Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M111.41 80.9707C110.92 81.2107 110.42 81.4507 109.9 81.6907"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M142.3 63.7307C141.99 62.3807 141.66 61.1707 141.32 60.1507C140.99 59.1407 140.66 58.3207 140.32 57.7207"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M53.9599 84.0996H193.05C194.93 84.0996 196.74 84.8496 198.07 86.1796C199.4 87.5096 200.15 89.3196 200.15 91.1996V191.2C200.15 193.08 199.4 194.89 198.07 196.22C196.74 197.55 194.93 198.3 193.05 198.3H53.9599C52.0799 198.3 50.2699 197.55 48.9399 196.22C47.6099 194.89 46.8599 193.08 46.8599 191.2V91.1996C46.8599 90.2696 47.0399 89.3396 47.3999 88.4796C47.7599 87.6196 48.2799 86.8396 48.9399 86.1796C49.5999 85.5196 50.3799 84.9996 51.2399 84.6396C52.0999 84.2796 53.0299 84.0996 53.9599 84.0996Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M59.7097 95.6901C59.7097 96.2101 59.5597 96.7101 59.2697 97.1401C58.9797 97.5701 58.5797 97.9001 58.0997 98.1001C57.6197 98.3001 57.0997 98.3501 56.5897 98.2501C56.0797 98.1501 55.6197 97.9001 55.2497 97.5401C54.8797 97.1701 54.6397 96.7101 54.5397 96.2001C54.4397 95.6901 54.4897 95.1701 54.6897 94.6901C54.8897 94.2101 55.2197 93.8001 55.6497 93.5201C56.0797 93.2301 56.5797 93.0801 57.0997 93.0801C57.4397 93.0801 57.7797 93.1501 58.0997 93.2801C58.4197 93.4101 58.7097 93.6001 58.9497 93.8501C59.1897 94.0901 59.3897 94.3801 59.5197 94.7001C59.6497 95.0201 59.7197 95.3601 59.7197 95.7001L59.7097 95.6901Z"
          fill="#2E2E2E"
        />
        <Path
          d="M46.8599 105.81H200.15"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M59.71 95.6893C59.71 96.2093 59.56 96.7093 59.27 97.1393C58.98 97.5693 58.58 97.8993 58.1 98.0993C57.62 98.2993 57.1 98.3493 56.59 98.2493C56.08 98.1493 55.62 97.8993 55.25 97.5293C54.88 97.1593 54.64 96.6993 54.53 96.1893C54.43 95.6793 54.48 95.1593 54.68 94.6793C54.88 94.1993 55.21 93.7893 55.64 93.5093C56.07 93.2193 56.57 93.0693 57.09 93.0693C57.43 93.0693 57.77 93.1393 58.09 93.2693C58.41 93.3993 58.7 93.5893 58.94 93.8393C59.18 94.0793 59.38 94.3693 59.51 94.6893C59.64 95.0093 59.71 95.3493 59.71 95.6893V95.6893Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M67.6397 95.6893C67.6397 96.2093 67.4897 96.7093 67.1997 97.1393C66.9097 97.5693 66.4997 97.8993 66.0297 98.0993C65.5497 98.2993 65.0297 98.3493 64.5197 98.2493C64.0097 98.1493 63.5497 97.8993 63.1797 97.5293C62.8097 97.1593 62.5697 96.6993 62.4597 96.1893C62.3597 95.6793 62.4097 95.1593 62.6097 94.6793C62.8097 94.1993 63.1397 93.7893 63.5697 93.5093C63.9997 93.2193 64.4997 93.0693 65.0197 93.0693C65.3597 93.0693 65.6997 93.1393 66.0197 93.2693C66.3397 93.3993 66.6297 93.5893 66.8697 93.8393C67.1097 94.0793 67.3097 94.3693 67.4397 94.6893C67.5697 95.0093 67.6397 95.3493 67.6397 95.6893V95.6893Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M75.5698 95.6893C75.5698 96.2093 75.4198 96.7093 75.1298 97.1393C74.8398 97.5693 74.4298 97.8993 73.9598 98.0993C73.4798 98.2993 72.9598 98.3493 72.4498 98.2493C71.9398 98.1493 71.4798 97.8993 71.1098 97.5293C70.7398 97.1593 70.4998 96.6993 70.3898 96.1893C70.2898 95.6793 70.3398 95.1593 70.5398 94.6793C70.7398 94.1993 71.0698 93.7893 71.4998 93.5093C71.9298 93.2193 72.4298 93.0693 72.9498 93.0693C73.2898 93.0693 73.6298 93.1393 73.9498 93.2693C74.2698 93.3993 74.5598 93.5893 74.7998 93.8393C75.0398 94.0793 75.2398 94.3693 75.3698 94.6893C75.4998 95.0093 75.5698 95.3493 75.5698 95.6893V95.6893Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M166.82 183.17V128.28C166.82 127.83 166.73 127.38 166.56 126.96C166.39 126.54 166.14 126.16 165.82 125.84C165.5 125.52 165.12 125.27 164.71 125.09C164.29 124.92 163.84 124.83 163.39 124.83H153.7C152.79 124.83 151.91 125.19 151.27 125.84C150.62 126.49 150.26 127.36 150.26 128.28V183.17"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M138.35 139.78H128.66C127.75 139.78 126.87 140.14 126.23 140.79C125.58 141.44 125.22 142.31 125.22 143.22V183.17H141.77V143.22C141.77 142.31 141.41 141.44 140.77 140.79C140.13 140.15 139.26 139.78 138.35 139.78Z"
          fill="#F3123C"
        />
        <Path
          d="M141.77 183.17V143.22C141.77 142.31 141.41 141.43 140.76 140.79C140.11 140.14 139.24 139.78 138.33 139.78H128.66C127.75 139.78 126.87 140.15 126.22 140.8C125.57 141.45 125.21 142.33 125.21 143.24V183.17"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M113.29 152.84H103.6C102.69 152.84 101.81 153.2 101.16 153.85C100.52 154.5 100.15 155.37 100.15 156.28V183.17H116.7V156.28C116.7 155.83 116.62 155.38 116.45 154.96C116.28 154.54 116.03 154.16 115.71 153.84C115.39 153.52 115.01 153.27 114.6 153.09C114.18 152.92 113.74 152.83 113.28 152.83L113.29 152.84Z"
          fill="#F3123C"
        />
        <Path
          d="M116.71 183.17V156.26C116.71 155.81 116.63 155.36 116.45 154.95C116.28 154.53 116.03 154.16 115.71 153.84C115.39 153.52 115.01 153.27 114.6 153.1C114.18 152.93 113.74 152.84 113.29 152.84H103.6C102.69 152.84 101.81 153.2 101.16 153.85C100.52 154.49 100.15 155.37 100.15 156.28V183.17"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M91.6799 183.17V165.4C91.6799 164.49 91.3199 163.61 90.6699 162.97C90.0199 162.32 89.1499 161.96 88.2399 161.96H78.5499C77.6399 161.96 76.7599 162.32 76.1199 162.97C75.4699 163.61 75.1099 164.49 75.1099 165.4V183.17"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M64.5298 183.17H188.23"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M177.59 177.4L188.23 183.17L177.59 188.92"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M64.5303 117V183.17"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M58.8101 127.66L64.5301 116.95L70.2501 127.66"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M145.4 21.6105C145.4 22.0805 145.26 22.5405 145 22.9305C144.74 23.3205 144.37 23.6305 143.93 23.8005C143.5 23.9805 143.02 24.0305 142.56 23.9405C142.1 23.8505 141.68 23.6205 141.35 23.2905C141.02 22.9605 140.79 22.5305 140.7 22.0705C140.61 21.6105 140.66 21.1305 140.83 20.7005C141.01 20.2705 141.31 19.9005 141.71 19.6305C142.1 19.3705 142.56 19.2305 143.03 19.2305C143.66 19.2305 144.26 19.4805 144.71 19.9305C145.16 20.3705 145.41 20.9805 145.41 21.6105H145.4Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M20.66 99.5605H13.58C12.75 99.5605 11.96 99.9006 11.37 100.481C10.79 101.071 10.46 101.871 10.46 102.691C10.46 103.521 10.8 104.311 11.38 104.901C11.97 105.481 12.76 105.811 13.59 105.811H17.51C18.34 105.811 19.13 106.131 19.72 106.721C20.31 107.301 20.64 108.101 20.64 108.931C20.64 109.761 20.32 110.551 19.73 111.141C19.15 111.731 18.35 112.061 17.52 112.061H10.5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M15.5698 97.2402V114.39"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M224.62 145.88L231.15 139.32L224.62 132.91L231.15 126.38L224.62 119.66L231.15 113.13L224.43 106.41"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M233.14 170.991L239.67 164.431L233.14 158.021L239.67 151.491L233.12 144.771L239.67 138.241L232.95 131.521"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M167.75 228.89C167.75 229.73 167.51 230.55 167.05 231.26C166.59 231.96 165.93 232.51 165.15 232.83C164.37 233.16 163.52 233.25 162.7 233.09C161.88 232.93 161.12 232.53 160.52 231.94C159.92 231.35 159.51 230.59 159.34 229.77C159.17 228.95 159.25 228.09 159.57 227.31C159.89 226.53 160.43 225.86 161.12 225.39C161.82 224.92 162.64 224.66 163.48 224.66C164.04 224.66 164.59 224.76 165.11 224.97C165.63 225.18 166.1 225.49 166.49 225.88C166.89 226.27 167.2 226.74 167.42 227.26C167.64 227.78 167.75 228.33 167.75 228.88V228.89Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M178.78 239.631C178.78 240.471 178.54 241.291 178.08 241.991C177.62 242.691 176.96 243.241 176.18 243.571C175.41 243.901 174.55 243.981 173.73 243.821C172.91 243.661 172.15 243.261 171.55 242.671C170.95 242.081 170.54 241.321 170.37 240.501C170.2 239.681 170.28 238.821 170.6 238.041C170.92 237.261 171.46 236.601 172.15 236.121C172.85 235.651 173.67 235.401 174.51 235.391C175.07 235.391 175.62 235.491 176.14 235.701C176.66 235.911 177.13 236.221 177.53 236.611C177.93 237.001 178.24 237.471 178.46 237.991C178.68 238.501 178.79 239.061 178.79 239.611L178.78 239.631Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M159.37 243.981L178.7 224.431"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_8955_170133">
          <Rect width={230.14} height={238.45} fill="white" transform="translate(10 6)" />
        </ClipPath>
      </Defs>
    </Svg>
  </Box>
)
